import { render, staticRenderFns } from "./tool_first.vue?vue&type=template&id=39976055&scoped=true&"
import script from "./tool_first.vue?vue&type=script&lang=js&"
export * from "./tool_first.vue?vue&type=script&lang=js&"
import style0 from "./tool_first.vue?vue&type=style&index=0&id=39976055&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39976055",
  null
  
)

export default component.exports